import footerlogo from "/footer.png";

function Footer() {
  return (
    <>
      {/*  Decommenter ici */}
      <div
        id="teconsent"
        style={{
          backgroundColor: " #dadfe0",
          height: "60px",
          width: "100%",
          textAlign: "center",
        }}
      ></div>
      <div
        id="consent-banner"
        style={{
          position: "fixed",
          bottom: 0,
          zIndex: 1040,
          maxHeight: "100vh",
          maxWidth: "100%",
          overflow: "auto",
        }}
      ></div>
      <footer className="footer">
        <img src={footerlogo} alt="logo Cartes sur table" />
      </footer>
    </>
  );
}

export default Footer;
